import PlaceShow from './place-show';

export default class PlaceShowDesktop extends PlaceShow {
}
